import { Fragment as i, isVNode as n, Comment as f, Text as u } from "vue";
const y = (r) => r.map((t) => t.type === i ? typeof t.children != "string" && t.children !== null ? y(t.children) : [t.children] : t).flat(), s = (r) => r.every((t) => n(t) ? t.type === f ? !0 : t.type === u || t.type === i ? t.children ? typeof t.children == "string" ? t.children.trim() === "" : Array.isArray(t.children) ? s(t.children) : !1 : !0 : !1 : !1), m = (r) => s([r]), p = (r) => {
  if (r) {
    if (typeof r == "string")
      return r.trim() || void 0;
    if (n(r) && r.type !== f) {
      if (r.type === u)
        return typeof r.children == "string" && r.children.trim() || void 0;
      if (r.children) {
        if (typeof r.children == "string")
          return r.children.trim() || void 0;
        if (Array.isArray(r.children)) {
          const t = r.children.map((e) => p(e)).filter((e) => e !== void 0);
          return t.length > 0 ? t.join(" ") : void 0;
        }
      }
    }
  }
};
export {
  p as getVNodeTextContent,
  m as isVNodeEmpty,
  y as skipFragment
};
